const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export const parseJsonString = (
  jsonString: string,
): Record<string, unknown> | null => {
  try {
    const parsedJsonString: unknown = JSON.parse(jsonString)
    return isObject(parsedJsonString) ? parsedJsonString : null
  }
  catch {
    return null
  }
}
